import { render, staticRenderFns } from "./CreateNilaiReagen.vue?vue&type=template&id=573b2618"
import script from "./CreateNilaiReagen.vue?vue&type=script&lang=js"
export * from "./CreateNilaiReagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports